import LimitesTed from "../../../components/acesso-rapido/transferir/limites-ted/LimitesTed";

export default function () {
  return <LimitesTed />;
}
